import { render } from "./BulkImportCard.vue?vue&type=template&id=de9e6c7c&scoped=true"
import script from "./BulkImportCard.vue?vue&type=script&lang=js"
export * from "./BulkImportCard.vue?vue&type=script&lang=js"

import "./BulkImportCard.vue?vue&type=style&index=0&id=de9e6c7c&lang=scss&scoped=true"

import exportComponent from "/Users/soil2sons/Projects/Work/Ensibuuko/hrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de9e6c7c"]])

export default __exports__